module.exports = {
      id: "british-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#british-flag",
      toString: function () {
        return this.url;
      }
    }